import { claimHandPixels } from "../../shared/claims.ts";

const PIXELS = claimHandPixels();

/**
 * The tiny pixel hand on a claimed board card ("Me do it", shared/claims.ts CLAIM_HAND): 7x7 art
 * pixels drawn as crisp rects, two CSS pixels each. Decorative; the card's name says "Hue is on it".
 */
export function ClaimHand() {
  return (
    <svg class="claim-hand" width="14" height="14" viewBox="0 0 7 7" shape-rendering="crispEdges" aria-hidden="true" focusable="false">
      {PIXELS.map((p) => (
        <rect key={`${p.x}-${p.y}`} x={p.x} y={p.y} width="1" height="1" fill={p.fill} />
      ))}
    </svg>
  );
}
